import React from 'react';
import { useSelector } from 'src/client/redux/modules/helpers/useSelector';
import NavigationLink from 'src/client/components/ui/NavigationLink';
import { useGetGalleryCoverUrl } from 'src/client/helpers/urls/useGetGalleryCoverUrl';

interface Props {
  item: {
    UUID: string;
    siteUUID: string;
    name: string;
    models: {
      name: string;
      path: string;
    }[];
    thumbnailCoverPath: string;
    path: string;
  };
  direction: 'previous' | 'next';
  cleanGalleryCover?: boolean;
}

export default function GalleryNavigationLink({ item, direction, cleanGalleryCover }: Props) {
  const contentCdnUrl = useSelector((state) => state.app.contentCdnUrl);
  const getGalleryCover = useGetGalleryCoverUrl();

  const galleryCover = getGalleryCover(contentCdnUrl, item, { clean: cleanGalleryCover, thumbnail: true });

  return (
    <NavigationLink
      text={item.name}
      imgSrc={galleryCover.url}
      url={item.path}
      subText={item.models.map((model) => model.name).join(' & ')}
      direction={direction}
      blurred={galleryCover.blurImage}
    />
  );
}
